var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPointOfSale)?_c('span',{staticClass:"point-of-sale-tag"},[_vm._v("Punto de Venta")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }